import { render, staticRenderFns } from "./ExibirExcecoesAjuizamento.vue?vue&type=template&id=0d7eaa58&"
import script from "./ExibirExcecoesAjuizamento.vue?vue&type=script&lang=js&"
export * from "./ExibirExcecoesAjuizamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports